import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IRanking, defaultValue } from '../../model/ranking.model';

export const ACTION_TYPES = {
  FETCH_RANKING_LIST: 'ranking/FETCH_RANKING_LIST',
  FETCH_RANKING: 'ranking/FETCH_RANKING',
  CREATE_RANKING: 'ranking/CREATE_RANKING',
  UPDATE_RANKING: 'ranking/UPDATE_RANKING',
  DELETE_RANKING: 'ranking/DELETE_RANKING',
  RESET: 'ranking/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IRanking>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type RankingState = Readonly<typeof initialState>;

// Reducer

export default (state: RankingState = initialState, action): RankingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_RANKING_LIST):
    case REQUEST(ACTION_TYPES.FETCH_RANKING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_RANKING):
    case REQUEST(ACTION_TYPES.UPDATE_RANKING):
    case REQUEST(ACTION_TYPES.DELETE_RANKING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_RANKING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_RANKING):
    case FAILURE(ACTION_TYPES.CREATE_RANKING):
    case FAILURE(ACTION_TYPES.UPDATE_RANKING):
    case FAILURE(ACTION_TYPES.DELETE_RANKING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_RANKING_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_RANKING):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_RANKING):
    case SUCCESS(ACTION_TYPES.UPDATE_RANKING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_RANKING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const apiUrl = 'api/rankings';

// Actions

export const getEntities: ICrudGetAllAction<IRanking> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_RANKING_LIST,
    payload: axios.get<IRanking>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IRanking> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_RANKING,
    payload: axios.get<IRanking>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IRanking> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_RANKING,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IRanking> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_RANKING,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IRanking> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_RANKING,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
